import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCopy, FiCheck, FiMaximize } = FiIcons;

const StandardGrid = ({ layoutWidth, copiedValue, copyToClipboard }) => {
  const columns = [
    { count: 1, label: '1 SPALTE', fraction: '1/1', percent: '100%' },
    { count: 2, label: '2 SPALTEN', fraction: '1/2', percent: '50%' },
    { count: 3, label: '3 SPALTEN', fraction: '1/3', percent: '33.3%' },
    { count: 4, label: '4 SPALTEN', fraction: '1/4', percent: '25%' },
    { count: 5, label: '5 SPALTEN', fraction: '1/5', percent: '20%' },
    { count: 6, label: '6 SPALTEN', fraction: '1/6', percent: '16.6%' }
  ];

  return (
    <section className="mb-16">
      {/* Unified Header - Exact Match to App.jsx */}
      <div className="flex items-center mb-8">
        <div className="w-10 h-10 rounded-[10px] bg-[#FFA22A] flex items-center justify-center mr-4 shadow-md shadow-orange-100">
          <SafeIcon icon={FiMaximize} className="text-white text-xl" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Standard-Raster</h2>
          <p className="text-sm text-gray-500 font-medium tracking-tight">Gleichmäßige Spaltenaufteilung</p>
        </div>
        <div className="hidden md:block h-px flex-1 bg-gray-200 ml-8 opacity-50"></div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {columns.map((col, idx) => {
          const width = Math.floor(layoutWidth / col.count);
          const id = `std-${idx}`;
          const isCopied = copiedValue === id;

          return (
            <motion.div
              key={id}
              className="bg-white rounded-[10px] p-8 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300 relative"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.05 }}
            >
              <div className="flex justify-between items-center mb-4">
                <span className="text-xs font-black text-gray-400 uppercase tracking-widest">
                  {col.label}
                </span>
                <button
                  onClick={() => copyToClipboard(width, id)}
                  className={`p-2 rounded-lg transition-colors ${isCopied ? 'text-green-500 bg-green-50' : 'text-gray-400 hover:text-[#FFA22A] hover:bg-orange-50'}`}
                >
                  <SafeIcon icon={isCopied ? FiCheck : FiCopy} className="text-lg" />
                </button>
              </div>

              <div className="mb-6 flex items-baseline">
                <span className="text-4xl font-black text-gray-900">{width}</span>
                <span className="text-xl text-gray-400 font-black ml-1">px</span>
              </div>

              <div className="flex gap-1.5 h-3 mb-8">
                {Array.from({ length: col.count }).map((_, i) => (
                  <div key={i} className="flex-1 bg-[#FFA22A] rounded-sm shadow-sm opacity-90"></div>
                ))}
              </div>

              <div className="space-y-3 pt-4 border-t border-gray-50">
                <div className="flex justify-between items-center text-sm">
                  <div className="flex items-center text-gray-500 font-bold">
                    <span className="w-2 h-2 rounded-full bg-[#FFA22A] mr-3"></span>
                    Breite
                  </div>
                  <div className="font-black text-gray-900">{col.fraction} Anteil</div>
                </div>
                <div className="flex justify-between items-center text-sm">
                  <div className="flex items-center text-gray-500 font-bold">
                    <span className="w-2 h-2 rounded-full bg-gray-200 mr-3"></span>
                    Fläche
                  </div>
                  <div className="font-black text-gray-900">{col.percent}</div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default StandardGrid;